import type { DemoState, DemoDictionaries } from './types';

const toMap = <T extends { id: string }>(items: T[]): Record<string, T> =>
  Object.fromEntries(items.map((item) => [item.id, item]));

/**
 * 业务字典默认值（选项列表，非业务数据）。
 * 租户可通过 /bff/dictionaries?scope=research 覆盖，
 * 前端在设置页（业务配置）里维护后随会话状态下发。
 */
const defaultDictionaries: DemoDictionaries = {
  topicTypes: ['行业', '赛道', '技术', '产业链', '投资主题', '区域产业', '其他'],
  topicStatuses: ['准备中', '研究中', '持续跟踪', '阶段完成', '暂停', '归档'],
  companyStatuses: [
    '普通关注',
    '重点跟踪',
    '潜在标的',
    '已接触',
    '已转投资项目',
    '暂不关注',
  ],
  viewpointStatuses: ['待验证', '初步成立', '持续验证', '已验证', '已修正', '已失效'],
  expertTypes: ['技术', '产业', '商业', '财务', '法律', '政策', '管理'],
  institutionTypes: [
    'VC',
    'PE',
    'CVC',
    '母基金',
    '政府引导基金',
    '产业资本',
    'S基金',
    '并购基金',
    '家族办公室',
    '其他',
  ],
  serviceTypes: [
    'FA',
    '律所',
    '会计师事务所',
    '券商',
    '投行',
    '咨询',
    '估值',
    '检测认证',
    '招聘',
    '其他',
  ],
  relationStatuses: ['尚未建立关系', '已建立联系', '重点关系', '已合作', '长期合作', '暂停合作'],
};

/**
 * 初始状态：所有业务记录为空。
 * 真实数据由 ResearchDataProvider 在挂载时从 /bff/research/* 分接口拉取并 hydrate；
 * 空租户展示空态，不再携带任何演示记录。
 */
export const createEmptyState = (): DemoState => ({
  topics: {},
  companies: {},
  materials: {},
  facts: toMap([]),
  viewpoints: toMap([]),
  conclusions: [],
  institutions: toMap([]),
  people: toMap([]),
  experts: toMap([]),
  services: toMap([]),
  tasks: [],
  communications: [],
  resourceUsages: [],
  projectLeads: toMap([]),
  activities: [],
  dictionaries: defaultDictionaries,
});

export { defaultDictionaries };
